import application from "stimulus_application";
import VideoController from "./video_controller";
import "./video.css";

application.register("video", VideoController);
